import type ClientCard from '@/modules/counterparty/models/card/client-card.js';

export type CounterpartySubordinationForm = {
  isSubordinated: boolean;
  parents: ClientCard[];
};

export function createEmptySubordinationForm(): CounterpartySubordinationForm {
  return {
    isSubordinated: false,
    parents: [],
  };
}
